module.exports = __webpack_public_path__ + "static/media/1920x10802.41053d6b.png";